import { createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";

const bookingSlice = createSlice({
  name: "bookings",
  initialState: {
    bookings: null,
    // Raw GET flags/jacket/{jacketId} response for the loaded record, kept
    // outside `bookings` so it never ends up in a save payload:
    // { jacketId, flags }. See getDisplayInvolvements in flagUtils.js.
    jacketFlags: null,
    LastBookingsFromAPI: null,
    bookingsFieldsEnabled: false,
    deleteAPis: [],
    isScheduledBooking: false,
    isTextSearch: false,
    isIrisSearch: false,
    irisSearchId: 0,
    irisEnrolleId: 0,
    manualBookingData: {
      isManualBooking: false,
    },
    showBookings: false,
    irisDeviceConnected: false, // Added to track iris device connection status
  },
  reducers: {
    setBookings: (state, action) => {
      state.bookings = { ...state?.bookings, ...action.payload };
    },
    setDeleteAPis: (state, action) => {
      state.deleteAPis = [...state?.deleteAPis, action.payload];
    },
    setDeleteAPIEmpty: (state) => {
      state.deleteAPis = [];
    },
    setDeleteAPisList: (state, action) => {
      state.deleteAPis = action.payload;
    },
    setBookingsNull: (state) => {
      state.bookings = null;
      state.jacketFlags = null;
    },
    setJacketFlags: (state, action) => {
      state.jacketFlags = action.payload;
    },
    setLastBookingsFromAPI: (state, action) => {
      state.LastBookingsFromAPI = action.payload;
    },
    setBookingsFieldsEnabled: (state, action) => {
      state.bookingsFieldsEnabled = action.payload;
    },
    setIsScheduledBooking: (state, action) => {
      state.isScheduledBooking = action.payload;
    },
    setShowBookings: (state, action) => {
      state.showBookings = action.payload;
    },
    setManualBookingData: (state, action) => {
      state.manualBookingData = action.payload;
    },
    setIrisDeviceConnected: (state, action) => {
      state.irisDeviceConnected = action.payload;
    },
    setIsTextSearch: (state, action) => {
      state.isTextSearch = action.payload;
    },
    setIsIrisSearch: (state, action) => {
      state.isIrisSearch = action.payload;
    },
    setIrisSearchId: (state, action) => {
      state.irisSearchId = action.payload;
    },
    setIrisEnrolleId: (state, action) => {
      state.irisEnrolleId = action.payload;
    },
  },
});

export const {
  setBookings,
  setDeleteAPis,
  setBookingsNull,
  setJacketFlags,
  setDeleteAPIEmpty,
  setDeleteAPisList,
  setLastBookingsFromAPI,
  setBookingsFieldsEnabled,
  setIsScheduledBooking,
  setShowBookings,
  setManualBookingData,
  setIrisDeviceConnected,
  setIsTextSearch,
  setIsIrisSearch,
  setIrisSearchId,
  setIrisEnrolleId,
} = bookingSlice.actions;
export default bookingSlice.reducer;
